import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class MenuListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "MenuListe";
    super(baseUrl);
  }


  getMenuListe( parentId?: number, sqId?:number){
    return this.get("", {params:{ parentId: parentId,sqId: sqId}});
  }
  getAdminMenuListe( parentId?: number, sqId?:number){
    return this.get("AdminMenuListe", {params:{ parentId: parentId,sqId: sqId}});
  }

}
export default new MenuListeAPI();
class MenuListeRequest {
  public parentId?: number;
  public sqId? : number;

  constructor( parentId?: number, sqId?:number) {
       
        this.parentId = parentId;
        this.sqId = sqId;
        

  }
}
export { MenuListeRequest };